// ScrollSpy component is in development
// https://github.com/mui-org/material-ui/issues/16359#issuecomment-617365879

import { useEffect, useMemo } from "react";
import throttle from "lodash/throttle";

/**
 * Hook to throttle scroll events from either a scroll container or window
 *
 * Supports both container-based scrolling (when scroll-container element exists)
 * and window/document scrolling (fallback).
 *
 * @param {Function|null} callback - Function to call on scroll (throttled)
 * @param {Object} options - Options object
 * @param {number} options.delay - Throttle delay in milliseconds (default: 166)
 */
const useThrottledOnScroll = (callback, { delay = 166 }) => {
  const throttledCallback = useMemo(
    () => (callback ? throttle(callback, delay) : noop),
    [callback, delay],
  );

  useEffect(() => {
    if (throttledCallback === noop) {
      return undefined;
    }

    // Get scroll container if it exists, otherwise use window
    // This supports both container-based scrolling (InteractiveModelerLayout)
    // and window-based scrolling (other pages)
    const scrollContainer = document.getElementById("scroll-container");
    const root = scrollContainer || window;

    root.addEventListener("scroll", throttledCallback);
    return () => {
      root.removeEventListener("scroll", throttledCallback);
      throttledCallback.cancel();
    };
  }, [throttledCallback]);
};

const noop = () => {};

export default useThrottledOnScroll;
